const o=5,t=12;export{t as DEFAULT_BAR_HEIGHT,o as DEFAULT_BORDER_RADIUS};
//# sourceMappingURL=ProgressIndicator.types.js.map
